/**
 *  @class
 *  @function CollectionTabs
 */

if (!customElements.get('collection-tabs')) {
  class CollectionTabs extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      setTimeout(() => {
        this.buttons = Array.from(this.querySelectorAll('button'));
        this.links = Array.from(this.closest('.collection-tabs').querySelectorAll('.linked-to-tab'));
        this.sectionHeader = this.closest('.section-header');
        if (!this.sectionHeader) return;
        this.target = this.dataset.target;

        // Get all per-block sliders
        this.panels = Array.from(
          document.getElementById(this.target)?.querySelectorAll('.collection-tab__panel') || []
        );

        // Init all panels once so arrows can measure scroll width
        this.initAllPanels();

        this.buttons.forEach((button, i) => {
          button.addEventListener('click', (event) => {
            this.toggleButtons(i);
            this.toggleLinks(i);
            this.togglePanel(i);
            event.preventDefault();
          });
        });

        if (Shopify.designMode) {
          this.addEventListener('shopify:block:select', (event) => {
            const index = this.buttons.indexOf(event.target);
            if (index !== -1) {
              this.buttons[index].dispatchEvent(new Event('click'));
            }
          });
        }
      }, 10);
    }

    // Briefly show all hidden panels so arrows can initialize properly
    initAllPanels() {
      this.panels.forEach((panel, i) => {
        if (i !== 0) {
          panel.style.visibility = 'hidden';
          panel.style.display = '';
          if (typeof panel.init === 'function') panel.init();
          this.bindArrows(panel);
          panel.style.display = 'none';
          panel.style.visibility = '';
        } else {
          // First panel is already visible — just bind arrows
          if (typeof panel.init === 'function') panel.init();
          this.bindArrows(panel);
        }
      });
    }

    // Bind prev/next arrow buttons to scroll the carousel
    bindArrows(panel) {
      const inner = panel.querySelector('.theme-scroll--inner');
      const prev = panel.querySelector('.flickity-prev');
      const next = panel.querySelector('.flickity-next');
      const carousel = panel.querySelector('.products.carousel');

      if (!inner || !prev || !next) return;

      // Remove disabled attribute
      prev.removeAttribute('disabled');
      next.removeAttribute('disabled');

      // Calculate scroll amount based on carousel width
      const getScrollAmount = () => carousel ? carousel.offsetWidth : 300;

      prev.addEventListener('click', () => {
        inner.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });

      next.addEventListener('click', () => {
        inner.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });

      // Update arrow states based on scroll position
      const updateArrowStates = () => {
        const atStart = inner.scrollLeft <= 0;
        const atEnd = inner.scrollLeft + inner.offsetWidth >= inner.scrollWidth - 1;
        prev.toggleAttribute('disabled', atStart);
        next.toggleAttribute('disabled', atEnd);
      };

      inner.addEventListener('scroll', updateArrowStates);
      updateArrowStates(); // Run once on init
    }

    toggleButtons(index) {
      this.buttons.forEach((button) => button.classList.remove('active'));
      this.buttons[index].classList.add('active');
    }

    toggleLinks(index) {
      if (this.links.length) {
        this.links.forEach((link) => link.classList.remove('active'));
        this.links[index].classList.add('active');
      }
    }

    togglePanel(index) {
      this.panels.forEach((panel, i) => {
        if (i === index) {
          panel.style.display = '';
          panel.querySelector('.theme-scroll--inner')?.scroll({ top: 0, left: 0 });
          if (typeof panel.init === 'function') panel.init();
          // Trigger resize so carousel recalculates widths
          window.dispatchEvent(new Event('resize'));
        } else {
          panel.style.display = 'none';
        }
      });
    }
  }

  customElements.define('collection-tabs', CollectionTabs);
}
